<template>
  <div class="page">
    
    <app-header></app-header> <hr>
     
     <div class="container">
        
            <ul class="nav nav-pills">
                <li class="nav-item slider__item" v-for="item in items" :key="item.id" @click="activeFilterIndex = item.id">
                    <a class="nav-link" data-toggle="pill" href="#allpic">
                      {{ item.message }}
                    </a>
                </li>
            </ul>

            
            <div class="tab-content">
                <div id="allpic" class="tab-pane active">
                  <div class="card rounded">

                  </div>
                  <div class="card-body">

                    <div class="row">
                      <div class="col-lg-4 mb-4 mb-lg-0" v-for="(image, i) in images" :src="image.path" :key="image.id" @click="index = i">
                        <div class="shadow-sm box mb-4">
                          <div class="with-border-image-sm">
                            <div class="position-relative overflow-hidden d-block">
                               <img class="image" :src="image.path">
                            </div>
                          </div>
                          <div class="p-2 border bg-white text-center">
                            <p> 
                                {{ image.caption }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="card-footer text-center">
                     <div class="gallery__button" :class="{'display-none': buttonNone}" id="buttonLoadMore" @click="loadMore()">Load more</div> 
                  </div>
                </div>
            </div>


     </div>

    <div class="gallery__wrapper">
      
      <div class="gallery__images">
        <app-gallery-slideshow :images="imagesForSlideShow" :index="index" @close="index = null"></app-gallery-slideshow>
      </div> 
     
    </div>
    
    <app-footer></app-footer>
  </div>
</template>
<script>
  import Header from '@/components/layout/NewHeader'
  import Footer from '@/components/layout/NewFooter'
  import VueGallerySlideshow from 'vue-gallery-slideshow'
  import GalleryServices from "../../services/GalleryServices";

  export default {
    computed: {
    navigationNext: function() { return `<span class="right">---</span>` },
    navigationPrev: function() { return `<span class="left">---</span>` }
    },
    data () {
      return {
        images: [],
        imagesForSlideShow: [],
        index: null,
        items: [
          { 
            id: 0,
            message: 'All Photos',
            filter: ''
          },
          { 
            id: 1,
            message: 'Events',
            filter: 'event'
          },
          { 
            id: 2,
            message: 'Library',
            filter: 'docLibrary'
          },
        ],
        activeFilterIndex: 0,
        currentPage: 1,
        buttonNone: false
      }
    },
    components: {
      'app-header': Header,
      'app-footer': Footer,
      'app-gallery-slideshow': VueGallerySlideshow,
    },
    mounted () {
      // console.log(this.activeFilterIndex, 'activeFilterIndex')
      this.addActiveFilter(this.activeFilterIndex)
      this.filter(0)
    },
    methods: {
      addActiveFilter(id) {
        const activeElement = document.getElementsByClassName("slider__item")[id]
        activeElement.classList.add("slider__item-active")
      },
      removeActiveFilter(id) {
        const activeElement = document.getElementsByClassName("slider__item")[id]
        activeElement.classList.remove("slider__item-active")
      },
      async filter(id) {
        this.buttonNone = false
        try {
          this.currentPage = 1
          const response = await GalleryServices.getBusinessAccounts(this.items[id].filter, this.currentPage)
          this.images = response.data.data
          if (this.images.length < 15) {
            this.buttonNone = true
          }
          // console.log(this.images.length, 'this.images')
          this.imagesForSlideShow = this.images.map(x => x.path);
        } catch (e) {
          console.log(e.response)
        }
      },
      async loadMore() {
        this.buttonNone = false
        // console.log('loadMore')
        this.currentPage++
        try {
          const response = await GalleryServices.getBusinessAccounts(this.items[this.activeFilterIndex].filter, this.currentPage)
          // console.log(response.data.data)
          let newPhotos = response.data.data
          if (newPhotos.length < 15) {
            this.buttonNone = true
          }
          let newPhotoSlides = newPhotos.map(x => x.path);
          this.images = [...this.images, ...newPhotos]
          this.imagesForSlideShow = [...this.imagesForSlideShow, ...newPhotoSlides];
        } catch (e) {
          console.log(e.response)
        }
      }
    },
    watch: {
      activeFilterIndex: function (newIndex, oldIndex) {
        this.addActiveFilter(newIndex)
        this.removeActiveFilter(oldIndex)
        this.filter(newIndex)
      }
    },
  }
</script>
<style lang="scss" scoped>
  .page{
    width: 100%;
  }
  .gallery {
    &__wrapper {
      width: 95%;
      max-width: 1200px;
      padding-top: 129px;
      padding-bottom: 76px;
      margin: 0 auto;
      padding-top: 90px;
      max-width: 1142px;
      @media screen and (max-width: 720px) {
        padding-top: 65px;
        padding-bottom: 34px;
      }
      @media screen and (max-width: 480px) {
        padding-top: 40px;
      }
    }
    &__header {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
      @media screen and (max-width: 480px) {
        padding-right: 6%;
      }
    }
    &__headline {
      display: flex;
    }
    &__text {
      @media screen and (max-width: 767px) {
        width: 100px;
      }
    }
    &__description {
      color: #adadad;
      font-family: "Open Sans";
      font-size: 12px;
      font-weight: 400;
      padding-bottom: 23px;
      // line-height: 36px;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      padding-bottom: 4px;
      padding-bottom: 14px;
      padding-top: 9px;
      white-space: nowrap
    }
    &__headline {
      color: #38383a;
      font-family: "Optimal C";
      font-size: 30px;
      font-weight: 400;
      // line-height: 407.78px;
      text-transform: uppercase;
      letter-spacing: 0.07px;
      position: relative;
      margin-bottom: 30px;
      // bottom: -20px;
      &:before {
        content: "";
        position: absolute;
        width: 63px;
        height: 3px;
        background-color: #2a9854;
        bottom: -27px;
        bottom: -20px;
      }
    }
    &__images {
      display: grid;
      grid-template-columns: repeat(3, auto);
      justify-content: space-between;
      align-items: center;
      row-gap: 25px;
      column-gap: 25px;
      margin-top: 75px;
      margin-bottom: 67px;
      @media screen and (max-width: 720px) {
        grid-template-columns: repeat(2, auto);
      }
      @media screen and (max-width: 600px) {
        grid-template-columns: repeat(1, auto);
        column-gap: 0;
      }
      @media screen and (max-width: 480px) {
        padding: 0 8%;
      }
      // display: flex;
      // flex-wrap: wrap;
      // justify-content: initial;
      // flex-direction: inherit;
      // align-items: center;
      // width: 100%;
    }
    &__button {
      width: 141px;
      height: 37px;
      background-color: #2a9854;
      color: #ffffff;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 400;
      line-height: 36px;
      letter-spacing: 0.35px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
  }
  .slider {
    width: 70%;
    margin: 0 20px;
    width: 65%;
    min-width: 130px;
    @media screen and (max-width: 720px) {
      width: 57%;
    }
    @media screen and (max-width: 600px) {
      width: 37%;
    }
    @media screen and (max-width: 767px) {
      width: 32%;
    }
    // position: relative;
    // padding: 0 30px;
    &__item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #aeaeb2;
      font-family: "Optimal C";
      font-size: 14px;
      font-weight: 400;
      line-height: 25px;
      letter-spacing: 0.7px;
      &-active{
        color: #2a9854;
      }
      h4 {
        cursor: pointer;
      }
    }
    .prev {
      position: absolute;
      top: 0;
      left: 0;
    }
    .next {
      position: absolute;
      top: 0;
      right: 0;
      right: -20px;
    }
  }
  .image {
    width: 100%;
    max-width: 388px;
    height: 260px;
    cursor: pointer;
    border-radius: 3px;
    object-fit: cover;
    @media screen and (max-width: 600px) {
      max-width: 100%;
      height: 260px;
    }
  }
.vgs {
  z-index: 99999;
  .vgs__container {
    top: 10vh !important;
  }
  &__container {
    top: 10vh !important;
  }
}

.display-none {
  display: none;
}

</style>

<style lang="scss">
.gallery__wrapper { 
  .owl-prev {
    width: 9px;
    height: 15px;
    background: url(../../../src/assets/svg/arrow_prev_carouser.svg) !important;
    background-size: contain !important;
    z-index: 1;
    margin: 0 !important;
    padding: 0 !important;
    color: transparent !important;
    left: -10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .owl-next {
    width: 9px;
    height: 15px;
    background: url(../../../src/assets/svg/arrow_next_carouser.svg) !important;;
    background-size: contain !important;
    z-index: 1;
    margin: 0 !important;
    padding: 0 !important;
    color: transparent !important;
    right: -10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .owl-nav {
    margin: 0 !important;
    height: 100% !important;
    position: absolute !important;
    top: -50% !important;
    transform: translateY(50%) !important;
    width: 100% !important;
  }
  .owl-stage-outer {
    z-index: 9;
  }
  .vgs__container{
    top: 10vh;
    @media screen and (max-width: 767px) { 
      top: 50%;
    }
  }
}
</style>